import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[highlight]',
})
export class HighlightDirective {
  constructor(private element: ElementRef, private renderer: Renderer2) {
    this.renderer.setStyle(this.element.nativeElement, 'color', '#fe3eaa');
    this.renderer.setStyle(
      this.element.nativeElement,
      'text-decoration',
      'underline'
    );
    this.renderer.setStyle(this.element.nativeElement, 'cursor', 'pointer');
  }
}
